import Swiper from 'swiper/dist/js/swiper';

export default {
  init() {

    $(document).ready(function() {

      $("a.back__top").on("click touchstart", function() {
        var el = $(this);
        var link = el.attr("href");
        window.location = link;
      });

      //forces right/left aligned figures to have the width of containing image.
      var $img = $('img.img-not-responsive');

      $img.parent('figure').removeAttr( 'style' ).css('cssText', 'width: ' + $img.attr('width') + 'px!important');

      // footer
      $('.footer-menu__title').next('ul').addClass('d-none');
      $('.menu-item-has-children .menu-link').next('ul').addClass('d-none');


      var resizeId;

      //initialize swiper when document ready
      new Swiper ('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        fadeEffect: {
          crossFade: true,
        },
        effect: 'fade',
        speed: 800,
        autoplay: {
          delay: 5000,
        },
        preloadImages: true,
        updateOnImagesReady: true,
        watchSlidesProgress: true,
        allowTouchMove: false,
        navigation: {
          nextEl: '.navigation__next',
          prevEl: '.navigation__prev',
        },
        pagination: {
          el: '.pagination',
          type: 'fraction',
        },
        on: {
          autoplayStop: function() {
            $('.slider__progress').remove();
          },
          init: function() {
            // make container the same height as the picture element
            var pictureHeight = $('.slider__image img').height();
            $('.slider__inner').css('height', pictureHeight);
            $('.slider__inner').css('opacity', '1');
          },
          slideChangeTransitionEnd: function() {
            $('.slider__progress').animate({ width: '100%'}, 5000, 'linear', function() { $('.slider__progress').css('width', '0')});
          },
          resize: function() {
            clearTimeout(resizeId);
            resizeId = setTimeout(doneResizing, 100);
          },
        },

        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
               ' of ' +
               '<span class="' + totalClass + '"></span>';
        },
      });

      function doneResizing() {
        // make container the same height as the picture element
        var pictureHeight = $('.slider__image img').height();
        $('.slider__inner').css('height', pictureHeight);
      }

      //mobile caption
      $('.show-caption').click(function() {
        $('.show-caption').toggleClass('active');
        $('.slider__caption p').toggleClass('active');
      });
    });

    $(window).scroll(function() {

        var distance_from_top = $(document).scrollTop();
        if ( distance_from_top > 2000 ) {

          $('.back__top').addClass('back__top--active');

        } else {

          $('.back__top').removeClass('back__top--active');

        }
    });

    $(document).ready(function() {

      //initialize swiper when document ready
      if($('.focusarea__container').length) {
        new Swiper ('.focusarea__container', {
          // Optional parameters
          direction: 'horizontal',
          loop: false,
          speed: 300,
          slidesPerView: 5,
          breakpoints: {
            420: {
              slidesPerView: 2,
            },
            576: {
              slidesPerView: 2.5,
            },
            800: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
          },
          navigation: {
            nextEl: '.navigation__next_focus',
            prevEl: '.navigation__prev_focus',
          },
        });
      }


    });

    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    //initialize swiper when document ready
    if($('.people__layout_charwrap').length) {
      var peopleSwiper = new Swiper ('.people__layout_charwrap', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 26,
        slideOffsetAfter: 50,
        spaceBetween: 10,
        simulateTouch: true,
        threshold: 20,
        breakpoints: {
          420: {
            slidesPerView: 6,
          },
          576: {
            slidesPerView: 8,
          },
          800: {
            slidesPerView: 10,
          },
          1000: {
            slidesPerView: 16,
          },
          1200: {
            slidesPerView: 20,
          },
        },
        navigation: {
          nextEl: '.navigation__next_people',
          prevEl: '.navigation__prev_people',
        },
      });

      //peopleSwiper.init();

      $('#researchTabs li a').click(function() {

        peopleSwiper.update();

      });
    }



  },
  finalize() {
    $('.footer-menu__title').click( function() {
      $(this).toggleClass('active').next('ul').toggleClass('d-block');
    });

    $('.menu-item-has-children > .menu-link').click( function(e) {
      e.preventDefault();
      $(this).toggleClass('active').next('ul').toggleClass('d-block');
    });

    //slider title darkening on hover
    $(document).on('mouseenter', '.slider__title a', function() {
      $('.hover__cover').css('opacity', '0.3');
    });
    $(document).on('mouseleave', '.slider__title a', function() {
      $('.hover__cover').css('opacity', '0');
    });

    $(window).on('resize scroll', function() {
      $('.red-line').each(function() {
        if ($(this).isInViewport()) {
          var titleWidth = $(this).prev('.line-title').width();
          $(this).width(titleWidth);
        }
      });
    });

    /* eslint-disable */

    // need to access jquery UI in plugin

    $('.ui-dialog').on('dialogopen', function(event, ui) {
      // needs to hang out for a sec
      setTimeout(function(){
        $('.red-line').each(function() {
            var titleWidth = $(this).prev('.line-title').width();
            $(this).width(titleWidth);
        });
      }, 300);
    });

    /* eslint-enable */

    $('.navbar-site-filter button').click(function() {
      $(this).toggleClass('active');
      $('.overlay').toggleClass('active');
      $('body').toggleClass('stop-scrolling');
    })

    $('.overlay__toggle').click(function() {
      $('.navbar-site-filter button').toggleClass('active');
      $('.overlay').toggleClass('active');
      $('body').toggleClass('stop-scrolling');
    })

    $('.overlay__close_area').click(function() {
      $('.overlay').toggleClass('active');
      $('body').toggleClass('stop-scrolling');
    });

    // Find all iframes
    var $iframes = $( "iframe" );

    // Find & save the aspect ratio for all iframes
    $iframes.each(function () {
      $(this).data( "ratio", this.height / this.width )
        // Remove the hardcoded width & height attributes
        .removeAttr( "width" )
        .removeAttr( "height" );
    });

    // Resize the iframes when the window is resized
    $( window ).resize( function () {
      $iframes.each( function() {
        var width = $(this).parent().width();
        $(this).width( width );
        // Get the parent container's width (if there's a ratio)
        if($(this).data("ratio")) {
          $(this).height( width * $(this).data( "ratio" ) );
        }
      });
    // Resize to fix all iframes on page load.
    }).resize();
  },
};

// Add smoothscroll behavior

$(document).ready(function(){

  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    var pagelink = this.hash.match(/^#page=([0-9]+)$/);
    var researchlink = this.hash.match(/^#research/);

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "" && !pagelink && !researchlink) {
      // Prevent default anchor click behavior
      event.preventDefault();

      if($('body').hasClass('template-people') && $('body').hasClass('admin-bar') && $('.alphabet-filter').hasClass('active')) {
        // accounting for height of admin bar and sticky nav
        var offset = 90;
      } else if($('body').hasClass('template-people') && $('body').hasClass('admin-bar')) {
        // accounting for height of admin bar and sticky nav PLUS inactive nav height lost
        offset = 150;
      } else if ($('body').hasClass('template-people') && $('.alphabet-filter').hasClass('active')) {
        // accounting for height sticky nav
        offset = 58;
      } else if($('body').hasClass('template-people')) {
        // accounting for height sticky nav (no admin) PLUS inactive nav height lost
        offset = 122;
      } else {
        offset = 0;
      }

      // Store hash
      var hash = this.hash;

      if(hash) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top - offset,
          }, 800, function(){
        });
      }

    } // End if
  });
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js